import { render, staticRenderFns } from "./MaterialTypeAllyList.vue?vue&type=template&id=6cc5c259&"
import script from "./MaterialTypeAllyList.vue?vue&type=script&lang=js&"
export * from "./MaterialTypeAllyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports